
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Grid = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M9.5,6V9.5H6V6H9.5M11,4.5H4.5V11H11V4.5Z"></path>
          <path d="M19,6V9.5H15.5V6H19m1.5-1.5H14V11h6.5V4.5Z"></path>
          <path d="M9.5,15.5V19H6V15.5H9.5M11,14H4.5v6.5H11V14Z"></path>
          <path d="M19,15.5V19H15.5V15.5H19M20.5,14H14v6.5h6.5V14Z"></path>
        </g>
      </g>
    </IconBase>);
};

Grid.defaultProps = {
  title: 'Grid',
};

export default Grid;
